const NotSupportMobile = () => {
	return (
		<section className="flex flex-col items-center justify-center w-full gap-4 px-8 h-dvh">
			<div className="space-y-2">
				<img
					src="/Logo.png"
					alt="logo"
					width={150}
					height={150}
					className="mx-auto"
				/>
				<h2 className="text-sm font-bold text-center text-primary">
					ກະຊວງການເງິນແຫ່ງ ສ.ປ.ປ ລາວ
				</h2>
				<h3 className="text-sm font-bold text-center text-primary">
					Ministry of Finance
				</h3>
			</div>

			<p className="text-center">
				ຂໍອະໄພໃນຄວາມບໍ່ສະດວກ, ລະບົບບໍ່ຮອງຮັບອຸປະກອນໂທລະສັບມືຖື ແລະ ແທັບເລັດ.
			</p>

			<img src={"/svg/not-support-mobile.svg"} alt="" />
		</section>
	);
};

export default NotSupportMobile;
